(function () {
  'use strict';

  var PRODUCT_RE = /organic-cordyceps-blend-immune-skin-support/i;
  var THEME_KEY = 'ld-cordyceps-stable-purchase-v10';
  var DATA = {
    one: { id: '42401954562130', label: '1 Bottle', price: '$67.99', button: 'BUY 1 BOTTLE - $67.99' },
    two: { id: '42401954594898', label: '2 Bottles', price: '$124.99', button: 'BUY 2 BOTTLES - $124.99' },
    sub: { id: '42401954562130', sellingPlan: '2580152402', price: '$50.99', compare: '$67.99', button: '$50.99 - SUBSCRIBE & SAVE' }
  };

  var state = { mode: 'onetime', qty: 'one' };
  var documentBound = false;
  var built = false;

  function isProductPage() {
    return PRODUCT_RE.test(location.pathname) || /Organic Cordyceps Blend/i.test(document.body.textContent || '');
  }

  function txt(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function visible(el) {
    return !!(el && el.getClientRects && el.getClientRects().length);
  }

  function hideExtraPanelImage() {
    if (!isProductPage()) return;
    var panels = Array.prototype.slice.call(document.querySelectorAll('.ld-product-panel'));
    panels.forEach(function (panel) {
      Array.prototype.slice.call(panel.querySelectorAll('img')).forEach(function (img) {
        if (img.closest('.ld-rating-link, .ld-avatar-row, .ld-payments, [data-ld-cordyceps-widget]')) return;
        var rect = img.getBoundingClientRect();
        if (rect.width < 110 && rect.height < 110) return;
        var target = img;
        while (target.parentElement && target.parentElement !== panel && target.parentElement.children.length === 1) {
          target = target.parentElement;
        }
        target.style.display = 'none';
        target.setAttribute('data-ld-hidden-extra-panel-image', 'true');
      });
    });
  }

  function findProductImageSrc() {
    return 'https://cdn.shopify.com/s/files/1/0595/8510/1906/files/luminaderm-cordyceps-subscribe-white-bg.png?v=1787481728';
  }

  function ensureStyles() {
    if (document.getElementById(THEME_KEY + '-style')) return;
    var style = document.createElement('style');
    style.id = THEME_KEY + '-style';
    style.textContent = [
      '.ld-cordyceps-widget{margin:18px 0 0;color:#242424;font-family:inherit;}',
      '.ld-cordyceps-widget--footer{max-width:788px;margin:18px auto 0!important;}',
      '.ld-cordyceps-widget--footer .ld-cordyceps-heading{display:none!important;}',
      '.ld-cordyceps-footer-image{display:none;}',
      '.ld-cordyceps-widget--footer .ld-cordyceps-footer-image{display:flex;justify-content:center;margin:0 auto 32px;}',
      '.ld-cordyceps-widget--footer .ld-cordyceps-footer-image img{display:block;width:min(260px,52vw);height:auto;aspect-ratio:1/1;object-fit:contain;background:#fff;}',
      '.ld-cordyceps-heading{font-weight:800;text-transform:uppercase;color:#47755f;font-size:15px;letter-spacing:.03em;margin:0 0 8px;}',
      '.ld-cordyceps-option{display:grid;grid-template-columns:24px minmax(0,1fr) auto auto;gap:12px;align-items:center;border:1px solid #c9c9c9;background:#f7fbff;min-height:94px;padding:17px 14px;cursor:pointer;}',
      '.ld-cordyceps-option.is-active{background:#edf8f1;border-color:#47755f;box-shadow:inset 0 0 0 1px #47755f;}',
      '.ld-cordyceps-radio{width:20px;height:20px;border:1px solid #a9a9a9;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;background:#fff;}',
      '.ld-cordyceps-option.is-active .ld-cordyceps-radio:after{content:"";width:10px;height:10px;border-radius:50%;background:#47755f;display:block;}',
      '.ld-cordyceps-title{font-size:22px;font-weight:800;line-height:1.15;}',
      '.ld-cordyceps-subtitle{font-size:15px;color:#696969;margin-top:3px;}',
      '.ld-cordyceps-save{display:inline-flex;align-items:center;justify-content:center;border:1px solid #d8dde1;background:#fff;padding:7px 16px;font-weight:800;font-size:13px;white-space:nowrap;}',
      '.ld-cordyceps-price{text-align:right;font-weight:900;font-size:34px;line-height:1;white-space:nowrap;}',
      '.ld-cordyceps-price small{display:block;font-size:13px;font-weight:500;margin-top:4px;}',
      '.ld-cordyceps-compare{display:block;font-size:13px;color:#777;text-decoration:line-through;font-weight:500;margin-bottom:3px;}',
      '.ld-cordyceps-perks{display:grid;grid-template-columns:1fr 1fr;gap:10px 22px;border:1px solid #d2d8df;border-top:0;background:#f4f8fc;padding:13px 14px 15px;}',
      '.ld-cordyceps-perk{display:flex;gap:8px;align-items:flex-start;font-size:15px;line-height:1.25;}',
      '.ld-cordyceps-check{width:18px;height:18px;border-radius:50%;border:1.5px solid #47755f;color:#47755f;display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;font-size:13px;font-weight:800;}',
      '.ld-cordyceps-divider{display:grid;grid-template-columns:1fr auto 1fr;gap:14px;align-items:center;color:#79756d;font-weight:800;margin:16px 0;}',
      '.ld-cordyceps-divider:before,.ld-cordyceps-divider:after{content:"";height:1px;background:#d7d0c5;display:block;}',
      '.ld-cordyceps-select{display:flex;flex-direction:column;gap:4px;min-width:128px;}',
      '.ld-cordyceps-select label{font-size:12px;text-align:center;color:#222;margin:0;line-height:1.1;}',
      '.ld-cordyceps-select select{height:38px;border:1px solid #b8b8b8;background:#fff;padding:0 12px;font-size:15px;border-radius:3px;}',
      '.ld-cordyceps-cta{width:100%;border:0;background:#111!important;color:#fff!important;min-height:70px;font-size:clamp(18px,2vw,23px)!important;font-weight:900!important;line-height:1.15!important;letter-spacing:.02em!important;text-transform:uppercase!important;text-align:center!important;cursor:pointer;margin-top:20px;text-shadow:0 1px 1px rgba(0,0,0,.35)!important;}',
      '.ld-cordyceps-cta[aria-busy="true"]{opacity:.72;pointer-events:none;}',
      '.ld-cordyceps-widget--footer .ld-cordyceps-option[data-ld-mode="onetime"]{grid-template-columns:24px minmax(0,1fr) 126px auto;min-height:92px;max-width:520px;}',
      '.ld-cordyceps-widget--footer .ld-cordyceps-cta{max-width:788px;}',
      '@media(max-width:749px){.ld-cordyceps-widget--footer{max-width:calc(100% - 28px)}.ld-cordyceps-widget--footer .ld-cordyceps-footer-image{margin-bottom:24px}.ld-cordyceps-widget--footer .ld-cordyceps-footer-image img{width:min(220px,62vw)}.ld-cordyceps-widget{margin-top:14px}.ld-cordyceps-option{grid-template-columns:22px minmax(0,1fr);gap:9px 10px;min-height:84px;padding:14px 12px}.ld-cordyceps-title{font-size:21px}.ld-cordyceps-save{grid-column:2;margin-top:8px;width:max-content}.ld-cordyceps-price{grid-column:1 / -1;text-align:left;font-size:32px}.ld-cordyceps-perks{grid-template-columns:1fr}.ld-cordyceps-select{grid-column:2;max-width:170px}.ld-cordyceps-widget--footer .ld-cordyceps-option[data-ld-mode="onetime"]{grid-template-columns:22px minmax(0,1fr);max-width:none}.ld-cordyceps-cta{min-height:68px;font-size:18px!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function widgetHtml() {
    return '' +
      '<div class="ld-cordyceps-widget" data-ld-cordyceps-widget>' +
        '<div class="ld-cordyceps-footer-image" data-ld-footer-image></div>' +
        '<div class="ld-cordyceps-heading">CHOOSE YOUR SUPPLY:</div>' +
        '<div class="ld-cordyceps-option" data-ld-mode="subscription" role="button" tabindex="0">' +
          '<span class="ld-cordyceps-radio" aria-hidden="true"></span>' +
          '<div><div class="ld-cordyceps-title">Subscribe and save</div><div class="ld-cordyceps-subtitle">30-Day Supply · ships monthly</div></div>' +
          '<span class="ld-cordyceps-save">SAVE 25%</span>' +
          '<div class="ld-cordyceps-price"><span class="ld-cordyceps-compare">$67.99</span>$50.99<small>/month</small></div>' +
        '</div>' +
        '<div class="ld-cordyceps-perks">' +
          '<div class="ld-cordyceps-perk"><span class="ld-cordyceps-check">✓</span><span>Includes 1 bottle of Organic Cordyceps Blend (60 Count)</span></div>' +
          '<div class="ld-cordyceps-perk"><span class="ld-cordyceps-check">✓</span><span>Free worldwide shipping on every order</span></div>' +
          '<div class="ld-cordyceps-perk"><span class="ld-cordyceps-check">✓</span><span>90-Day risk-free money-back guarantee</span></div>' +
          '<div class="ld-cordyceps-perk"><span class="ld-cordyceps-check">✓</span><span>Cancel or skip anytime</span></div>' +
        '</div>' +
        '<div class="ld-cordyceps-divider">OR</div>' +
        '<div class="ld-cordyceps-option" data-ld-mode="onetime" role="button" tabindex="0">' +
          '<span class="ld-cordyceps-radio" aria-hidden="true"></span>' +
          '<div><div class="ld-cordyceps-title">One-time purchase</div></div>' +
          '<div class="ld-cordyceps-select"><label>Select Quantity</label><select data-ld-qty><option value="one">1 Bottle</option><option value="two">2 Bottles</option></select></div>' +
          '<div class="ld-cordyceps-price" data-ld-one-price>$67.99</div>' +
        '</div>' +
        '<button type="button" class="ld-cordyceps-cta" data-ld-cta>BUY 1 BOTTLE - $67.99</button>' +
      '</div>';
  }

  function attachFooterImage(widget) {
    if (!widget || !widget.classList.contains('ld-cordyceps-widget--footer')) return;
    var slot = widget.querySelector('[data-ld-footer-image]');
    if (!slot || slot.querySelector('img')) return;
    var src = findProductImageSrc();
    if (!src) return;
    var img = document.createElement('img');
    img.src = src;
    img.alt = 'Organic Cordyceps Blend product image';
    img.loading = 'lazy';
    img.decoding = 'async';
    slot.appendChild(img);
  }

  function cleanupOldBuilds() {
    document.querySelectorAll('[data-ld-cordyceps-widget]').forEach(function (el) { el.remove(); });
    document.querySelectorAll('[data-ld-hidden-old-purchase="true"]').forEach(function (el) {
      el.style.display = '';
      el.removeAttribute('data-ld-hidden-old-purchase');
    });
  }

  function purchaseWrappers() {
    var all = Array.prototype.slice.call(document.querySelectorAll('form,section,div'));
    var matches = all.filter(function (el) {
      if (!visible(el) || el.closest('[data-ld-cordyceps-widget]')) return false;
      var t = txt(el);
      return /subscribe and save/i.test(t) && /one-time purchase/i.test(t) && /\$50\.99|\$67\.99|\$74\.99|\$59\.99/i.test(t) && t.length > 100 && t.length < 2800;
    }).sort(function (a, b) { return txt(a).length - txt(b).length; });

    var chosen = [];
    matches.forEach(function (el) {
      if (chosen.some(function (picked) { return picked.contains(el) || el.contains(picked); })) return;
      chosen.push(el);
    });
    return chosen;
  }

  function buildWidgets(force) {
    if (built && !force) return;
    built = true;
    cleanupOldBuilds();
    var wrappers = purchaseWrappers();
    wrappers.forEach(function (oldWrap, index) {
      var holder = document.createElement('div');
      holder.innerHTML = widgetHtml();
      var widget = holder.firstElementChild;
      var isFooter = !!oldWrap.closest('.ld-subscribe, .section-luminaderm-subscribe');
      if (isFooter) widget.classList.add('ld-cordyceps-widget--footer');
      oldWrap.parentElement.insertBefore(widget, oldWrap);
      oldWrap.setAttribute('data-ld-hidden-old-purchase', 'true');
      oldWrap.style.display = 'none';
      attachFooterImage(widget);
    });
    updateAll();
  }

  function updateAll() {
    document.querySelectorAll('[data-ld-cordyceps-widget]').forEach(function (widget) {
      widget.querySelectorAll('[data-ld-mode]').forEach(function (option) {
        option.classList.toggle('is-active', option.getAttribute('data-ld-mode') === state.mode);
      });
      attachFooterImage(widget);
      var select = widget.querySelector('[data-ld-qty]');
      if (select) select.value = state.qty;
      var onePrice = widget.querySelector('[data-ld-one-price]');
      if (onePrice) onePrice.textContent = DATA[state.qty].price;
      var cta = widget.querySelector('[data-ld-cta]');
      if (cta) cta.textContent = state.mode === 'subscription' ? DATA.sub.button : DATA[state.qty].button;
    });
    hideExtraPanelImage();
  }

  function selectedItem() {
    if (state.mode === 'subscription') return { id: DATA.sub.id, quantity: 1, selling_plan: DATA.sub.sellingPlan };
    return { id: DATA[state.qty].id, quantity: 1 };
  }

  function postJson(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body || {}) });
  }

  function checkout(cta) {
    if (cta && cta.getAttribute('aria-busy') === 'true') return;
    if (cta) cta.setAttribute('aria-busy', 'true');
    postJson('/cart/clear.js').catch(function () {})
      .then(function () { return postJson('/cart/add.js', { items: [selectedItem()] }); })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
      .catch(function () { if (cta) cta.removeAttribute('aria-busy'); alert('Checkout could not start. Please refresh the page and try again.'); });
  }

  function bindDocument() {
    if (documentBound) return;
    documentBound = true;
    document.addEventListener('click', function (event) {
      if (!isProductPage()) return;
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      var widget = target.closest('[data-ld-cordyceps-widget]');
      if (!widget) return;
      var option = target.closest('[data-ld-mode]');
      if (option) {
        event.preventDefault();
        state.mode = option.getAttribute('data-ld-mode') === 'subscription' ? 'subscription' : 'onetime';
        updateAll();
        return;
      }
      var cta = target.closest('[data-ld-cta]');
      if (cta) { event.preventDefault(); checkout(cta); }
    }, true);

    document.addEventListener('change', function (event) {
      var select = event.target && event.target.closest && event.target.closest('[data-ld-qty]');
      if (!select || !select.closest('[data-ld-cordyceps-widget]')) return;
      state.qty = select.value === 'two' ? 'two' : 'one';
      state.mode = 'onetime';
      updateAll();
    }, true);
  }

  function run(force) {
    if (!isProductPage()) return;
    ensureStyles();
    buildWidgets(force);
    bindDocument();
    updateAll();
    hideExtraPanelImage();
  }

  document.addEventListener('DOMContentLoaded', function () { run(false); });
  document.addEventListener('shopify:section:load', function () { built = false; window.setTimeout(function () { run(true); }, 100); });
  window.setTimeout(function () { run(false); }, 80);
  window.setTimeout(function () { run(false); }, 700);
  window.setTimeout(function () { run(false); }, 1600);
  window.setTimeout(hideExtraPanelImage, 2400);
})();
